import http from "./httpService";

let apiUrl = "";
if (process.env.NODE_ENV === "production") {
  apiUrl = "https://api.smartciti.com.ng/huawei-smartax/";
} else if (process.env.REACT_APP_ENV === "staging") {
  apiUrl = "https://staging.smartciti.com.ng/huawei-smartax/";
} else {
  apiUrl = "http://localhost:8000/huawei-smartax/";
}

export async function addOnt(payload) {
  const url = apiUrl + "add-ont";
  return await http.post(url, payload);
}

export async function deleteOnt(payload) {
  const url = apiUrl + "delete-ont";
  return await http.post(url, payload);
}

export async function restartOnt(payload) {
  const url = apiUrl + "reset-ont";
  return await http.post(url, payload);
}

export async function getOntOpticalInfo(payload) {
  const url = apiUrl + "get-ont-optical-info";
  return await http.post(url, payload);
}

export async function getOntWanInfo(payload) {
  const url = apiUrl + "get-ont-wan-info";
  return await http.post(url, payload);
}

export async function getOntInfo(payload) {
  const url = apiUrl + "get-ont-info";
  return await http.post(url, payload);
}
